module.exports = __webpack_public_path__ + "static/Givehome-4fb5e0c11507b264cb86d0e24c83f45f.png";